import { useState } from "react";

interface Props {
  onLogin: (id: string, pw: string) => boolean;
}

const AdminLogin = ({ onLogin }: Props) => {
  const [id, setId] = useState("");
  const [pw, setPw] = useState("");
  const [error, setError] = useState("");
  const [showPw, setShowPw] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    await new Promise((r) => setTimeout(r, 600));
    const ok = onLogin(id, pw);
    setLoading(false);
    if (!ok) setError("IDまたはパスワードが正しくありません");
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center bg-gradient-to-br from-pink-50 to-rose-50"
      style={{ fontFamily: "'Nunito', sans-serif" }}
    >
      <div className="w-full max-w-sm mx-4">
        <div className="text-center mb-8">
          <img
            src="https://public.readdy.ai/ai/img_res/db459360-20e7-4f18-828f-b6f77daa6c55.png"
            alt="Girls' Map"
            className="h-16 w-auto object-contain mx-auto mb-3"
          />
          <h1
            className="text-2xl font-bold text-pink-500"
            style={{ fontFamily: "'Pacifico', cursive" }}
          >
            Girls&apos; Map
          </h1>
          <p className="text-gray-500 text-sm mt-1">管理画面</p>
        </div>

        <div className="bg-white rounded-2xl p-8 border border-pink-100">
          <h2 className="text-lg font-bold text-gray-800 mb-6 text-center">ログイン</h2>
          <form onSubmit={handleSubmit} className="flex flex-col gap-4">
            <div>
              <label className="text-xs font-semibold text-gray-600 mb-1 block">管理者ID</label>
              <div className="relative">
                <i className="ri-user-line absolute left-3 top-1/2 -translate-y-1/2 text-pink-400 text-sm"></i>
                <input
                  type="text"
                  value={id}
                  onChange={(e) => setId(e.target.value)}
                  placeholder="管理者ID"
                  className="w-full pl-9 pr-4 py-2.5 border border-pink-200 rounded-xl text-sm focus:outline-none focus:border-pink-400 bg-pink-50/30"
                  required
                />
              </div>
            </div>
            <div>
              <label className="text-xs font-semibold text-gray-600 mb-1 block">パスワード</label>
              <div className="relative">
                <i className="ri-lock-line absolute left-3 top-1/2 -translate-y-1/2 text-pink-400 text-sm"></i>
                <input
                  type={showPw ? "text" : "password"}
                  value={pw}
                  onChange={(e) => setPw(e.target.value)}
                  placeholder="パスワード"
                  className="w-full pl-9 pr-10 py-2.5 border border-pink-200 rounded-xl text-sm focus:outline-none focus:border-pink-400 bg-pink-50/30"
                  required
                />
                <button
                  type="button"
                  onClick={() => setShowPw(!showPw)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-pink-400 cursor-pointer"
                >
                  <i className={showPw ? "ri-eye-off-line" : "ri-eye-line"}></i>
                </button>
              </div>
            </div>

            {error && (
              <div className="bg-red-50 border border-red-200 text-red-500 text-xs rounded-xl px-3 py-2 flex items-center gap-2">
                <i className="ri-error-warning-line"></i>{error}
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              className="w-full py-3 bg-gradient-to-r from-pink-400 to-rose-400 text-white rounded-full font-bold text-sm hover:from-pink-500 hover:to-rose-500 transition-all disabled:opacity-60 cursor-pointer whitespace-nowrap"
            >
              {loading ? (
                <span className="flex items-center justify-center gap-2">
                  <i className="ri-loader-4-line animate-spin"></i>ログイン中...
                </span>
              ) : (
                "ログイン"
              )}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
